module.exports = __webpack_public_path__ + "static/media/favorito.05732e51.svg";